import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route ,RouterModule} from '@angular/router';
import { UserAuthenticateGuard } from './shared/services/user-authenticate.gaurd';

const routes:Route[] =[
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', loadChildren: './login/login.module#LoginModule' },
    { path: 'password', loadChildren: './password/password.module#PasswordModule' },
    { path: 'dashboard', loadChildren: './landing-page/landing-page.module#LandingPageModule', }, // canActivate: [UserAuthenticateGuard]
    {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full',
    }
]
@NgModule({
  imports: [
    RouterModule.forRoot(routes,{useHash:true}),
  ],
  exports:[
    RouterModule
  ]
})
export class AppRoutingModule { }
